import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { X } from 'phosphor-react';
import { cn } from './cn';
import { Eyebrow } from './Tag';
import { IconButton } from './Button';

const SIZES = { sm: 'max-w-md', md: 'max-w-lg', lg: 'max-w-2xl' };

// Glass-overlay modal with a Double-Bezel panel. Backdrop blur is allowed here (fixed overlay).
export function Modal({ open, onClose, title, eyebrow, children, footer, size = 'md' }) {
    return (
        <Transition show={open} as={Fragment}>
            <Dialog onClose={onClose} className="relative z-50">
                <Transition.Child as={Fragment}
                    enter="duration-300 ease-fluid" enterFrom="opacity-0" enterTo="opacity-100"
                    leave="duration-200 ease-fluid" leaveFrom="opacity-100" leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-espresso/40 backdrop-blur-md" aria-hidden="true" />
                </Transition.Child>

                <div className="fixed inset-0 flex items-center justify-center p-4">
                    <Transition.Child as={Fragment}
                        enter="duration-400 ease-fluid" enterFrom="opacity-0 translate-y-4 scale-[0.98]" enterTo="opacity-100 translate-y-0 scale-100"
                        leave="duration-200 ease-fluid" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-[0.98]">
                        <Dialog.Panel className={cn('w-full max-h-[85dvh] overflow-y-auto rounded-squircle bg-espresso/[0.035] p-1.5 ring-1 ring-espresso/10 shadow-ambient-lg', SIZES[size])}>
                            <div className="rounded-squircle-inner bg-cream-50 shadow-inner-hi">
                                <div className="flex items-start justify-between gap-4 px-4 pt-5 md:px-7 md:pt-7">
                                    <div>
                                        {eyebrow && <Eyebrow className="mb-3">{eyebrow}</Eyebrow>}
                                        <Dialog.Title className="font-serif text-2xl text-espresso">{title}</Dialog.Title>
                                    </div>
                                    <IconButton icon={X} label="Đóng" variant="ghost" onClick={onClose} className="-mr-2 -mt-1" />
                                </div>
                                <div className="px-4 py-5 md:px-7 md:py-6">{children}</div>
                                {footer && <div className="flex flex-wrap justify-end gap-3 border-t border-espresso/[0.07] px-4 py-4 md:px-7 md:py-5">{footer}</div>}
                            </div>
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    );
}
